import React from 'react';
import PropTypes from 'prop-types';
import css from './InputText.module.scss';

const InputText = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  type = 'text',
  required = false,
  disabled = false,
  autoComplete = true,
  className = '',
  name,
  icon,
  autoFocus = false,
  onKeyDown
}) => {
  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <div className={`${css.inputContainer} ${className}`}>
      {label && (
        <label className={css.label}>
          {label}
          {required && <span className={css.required}>*</span>}
        </label>
      )}
      <div className={css.inputWrapper}>
        {icon && <div className={css.iconContainer}>{icon}</div>}
        <input
          type={type}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          name={name}
          autoFocus={autoFocus}
          autoComplete={autoComplete ? 'on' : 'off'}
          onKeyDown={onKeyDown}
          className={`${css.input} ${error ? css.error : ''} ${icon ? css.hasIcon : ''}`}
          data-error={!!error}
        />
      </div>
      {error && <span className={css.errorMessage}>{error}</span>}
    </div>
  );
};

InputText.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  autoFocus: PropTypes.bool,
  onKeyDown: PropTypes.func
};

export default InputText;
